import { useEffect } from "react";
import { useLocation } from "wouter";
import { useAuthStore } from "@/hooks/useAuthStore";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated } = useAuthStore();
  const [location, setLocation] = useLocation();

  useEffect(() => {
    if (!isAuthenticated) {
      // Save the current path to redirect back after login
      // Include query parameters to preserve Phantom mobile response data
      sessionStorage.setItem("redirectAfterLogin", location + window.location.search);
      // Redirect to login page with the intended destination
      setLocation(`/login?redirect=${encodeURIComponent(location + window.location.search)}`);
    }
  }, [isAuthenticated, location, setLocation]);

  // Don't render children if not authenticated
  if (!isAuthenticated) {
    return null;
  }

  return <>{children}</>;
}
